import React, { useEffect } from 'react';
import styles from './GameMobileAd.css';

interface GameMobileAdProps {
  componentId: string;
  dataElementDescription: string;
  dimensions: [number, number][];
}

const GameMobileAd: React.FC<GameMobileAdProps> = () => {
  useEffect(() => {
    if (window && (window as any).AARP && (window as any).AARP.ads) {
      (window as any).AARP.ads.loadAd("ad-mobile-gameplay", "6x6");
    }

    return () => {
      const { googletag } = window as any;
      if (googletag && googletag.destroySlots) {
        const slots = googletag.pubads().getSlots();
        const slotToDestroy = slots.find(slot => slot.getSlotElementId() === "ad-mobile-gameplay");
        if (slotToDestroy) {
          googletag.destroySlots([slotToDestroy]);
        }
      }
    };
  }, []);

  return (
    <div className={styles['aarp-c-ad__container--mobile-gameplay']} id="ad-mobile-gameplay" data-adsize="6x6"></div>
  );
}

export default GameMobileAd;
